import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import css from './RenderFeaturedLocations.module.css';
import Slider from 'react-slick';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';
import { ListingCard } from '../../../components';
import useVirtualTourAvailabilities from '../../../components/listing/useVirtualTourAvailabilities';
import { useDispatch, useSelector } from 'react-redux';
import { useConfiguration } from '../../../context/configurationContext';
import { getListingsById } from '../../../ducks/marketplaceData.duck';
import { cardRenderSizes } from '../../SearchPage/SearchResultsPanel/SearchResultsPanel';
import { fetchNewestListings } from '../../LandingPage/LandingPage.duck';
import { getNewestListingsSliderSettings, getUniqueListings } from './newListingsCarousel';

function RenderFeaturedLocations() {
  const intl = useIntl();
  const config = useConfiguration();

  const dispatch = useDispatch();

  const state = useSelector(state => state);
  const newestListingIds = useSelector(state => state.LandingPage?.newestListingIds || []);
  const listings = getUniqueListings(getListingsById(state, newestListingIds));
  const virtualTourAvailability = useVirtualTourAvailabilities(listings);

  useEffect(() => {
    dispatch(fetchNewestListings(config)).catch(() => {
      // The landing reducer records the failure and keeps stale search-page
      // results out of this dedicated carousel.
    });
  }, [config, dispatch]);

  if (listings.length === 0) {
    return null;
  }

  const sliderSettings = getNewestListingsSliderSettings(listings.length);

  return (
    <div className={css.sectionLocations}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>
              {intl.formatMessage({
                id: 'RenderFeaturedLocations.heading',
                defaultMessage: 'Our most unique locations',
              })}
            </h2>
            <p>
              {intl.formatMessage({
                id: 'RenderFeaturedLocations.subheading',
                defaultMessage:
                  'Most liked and popular locations, unique, thrilling and listed on our customer’s top picks.',
              })}
            </p>
          </div>
        </div>
        <div className={css.categorySlider}>
          <Slider {...sliderSettings}>
            {listings.map(l => (
              <ListingCard
                className={css.listingCard}
                key={l.id.uuid}
                listing={l}
                hasVirtualTour={virtualTourAvailability[l.id.uuid] === true}
                renderSizes={cardRenderSizes(true)}
                setActiveListing={() => {}}
              />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default RenderFeaturedLocations;
